import React from 'react';
import { Box, CircularProgress } from '@mui/material';

/**
 * Écran bref pendant la résolution du contexte département au boot
 * (le temps de savoir si l'utilisateur est mono-département) — évite un
 * flash du sélecteur de département suivi d'une redirection immédiate.
 */
const AppBootScreen: React.FC = () => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: '#f4f5f7',
    }}
  >
    <CircularProgress sx={{ color: '#2563eb' }} />
  </Box>
);

export default AppBootScreen;
